document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('WaterfallGallery');
    if (!section) return;
  
    gsap.registerPlugin(ScrollTrigger);
  
    const columns = gsap.utils.toArray('.waterfall-gallery__column');
  
    columns.forEach((column, index) => {
      const direction = index % 2 === 0 ? 1 : -1;
  
      gsap.fromTo(
        column,
        { y: direction * 80 },
        {
          y: 0,
          scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
          ease: 'power1.out'
        }
      );
    });
  });